/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (connectionTypes) => ({
    type: actions.CONNECTION_TYPES_RECEIVE,
    payload: { connectionTypes },
});